import primeCrestImg from "../../assets/images/primeCrest.png";
import plusCrestImg from "../../assets/images/plusCrest.png";
import styles from "./primeBadge.module.css";

// Raised 2026-10-21 (was 14 / 18 / 24): the crests were hard to make out.
// The art is 120px, so it stays sharp at these sizes.
const SIZE_BY_KEY = {
  small: 20,
  medium: 24,
  large: 30,
};

// Each Prime tier has its own crest — the same art the app shows, so admins
// see the tier a player actually has.
const TIER_BADGES = {
  prime2: { src: primeCrestImg, label: "Prime" },
  prime1: { src: plusCrestImg, label: "Plus" },
};

// `isPrime` without a known tier (legacy grants) keeps the Prime crest.
const PrimeBadge = ({ isPrime, primeTier, size = "medium", className = "" }) => {
  const badge = TIER_BADGES[primeTier] ?? (isPrime ? TIER_BADGES.prime2 : null);
  if (!badge) return null;

  const pixelSize =
    typeof size === "number" ? size : SIZE_BY_KEY[size] || SIZE_BY_KEY.medium;

  return (
    <img
      src={badge.src}
      alt={badge.label}
      title={badge.label}
      className={`${styles.badge} ${className}`.trim()}
      style={{ width: pixelSize, height: pixelSize }}
    />
  );
};

export default PrimeBadge;
